/*
  MAM Forni "Build your oven" — shared builder engine (2026-10-03).

  Used by:
    - snippets/fwo-mam-builder.liquid (product page; window.fwoMamBuilder)
    - assets/quote-form.js (pop-up when a MAM product is picked in the quote
      form's product search, so a request can't be sent without a build)

  Data comes from snippets/fwo-mam-builder-data.liquid (inline on the product
  page, or via /products/<handle>?view=mambuilder for the quote form):
    { config: {axes, images}, units: [{id,title,qty,media}], special: <variant id>,
      media: [{id, file, src, srcset}] }
  `config` is the product's custom.mam_builder metafield — see
  firewood-oven-theme/CLAUDE.md § MAM "Build your oven".

  FwoMamBuilder.create(rootEl, data, { showMedia(mediaObj) }) renders into rootEl
  (which must contain FwoMamBuilder.shellHtml()) and returns
  { missing(), showMissing(list, scroll), spec(), variantId() }.

  The two themes keep their own copy of this file; ONLY the THEME block
  (markup classes + CSS) differs. Keep the rest identical.
*/
(function () {
  if (window.FwoMamBuilder) return;

  // ---- THEME block (Homestead) ----
  var THEME = {
    group: 'fwo-config__group',       // fieldset per axis
    legend: 'fwo-config__legend',
    options: 'fwo-config__options',   // pill row
    selected: 'fwo-config__option--selected',
    pillText: 'fwo-config__title',
    optionalStyle: 'font-weight:400;color:#6b6258',
    css: [
      '.fwo-mam { margin: 4px 0 18px; }',
      '.fwo-mam__head { font-weight: 800; font-size: 1.6rem; margin: 0 0 4px; }',
      '.fwo-mam__sub { color: #6b6258; font-size: 1.35rem; margin: 0 0 14px; }',
      '.fwo-mam .fwo-config__group { margin: 0 0 14px; border: 0; padding: 0; }',
      '.fwo-mam .fwo-config__options { display: flex; flex-wrap: wrap; gap: 8px; }',
      '.fwo-mam .fwo-config__option[aria-disabled="true"] { opacity: .4; cursor: not-allowed; }',
      '.fwo-mam__desc { color: #6b6258; font-size: 1.3rem; margin-top: 6px; min-height: 1em; }',
      '.fwo-mam__text { width: 100%; max-width: 420px; padding: 10px 12px; border: 1px solid rgba(28,24,20,.22); border-radius: 8px; font: inherit; }',
      '.fwo-mam__photo-note { font-size: 1.3rem; color: #6b6258; background: #f8f9fa; border-radius: 6px; padding: 8px 10px; margin: 0 0 14px; }',
      '.fwo-mam__summary { font-size: 1.3rem; background: #f8f9fa; border-radius: 6px; padding: 10px 12px; margin: 0 0 6px; line-height: 1.5; }',
      '.fwo-mam__missing { color: #B40C1C; font-weight: 600; font-size: 1.35rem; margin: 6px 0 0; }',
      '.fwo-mam__qty { font-weight: 500; color: #6b6258; }',
      // Long labels (an in-stock unit's full spec) wrap inside the pill instead of running off the page.
      '.fwo-mam .fwo-config__option { max-width: 100%; white-space: normal; line-height: 1.35; }',
      '.fwo-mam .fwo-config__title { overflow-wrap: anywhere; }'
    ].join('\n')
  };
  // ---- end THEME block ----

  function ensureStyles() {
    if (document.getElementById('fwo-mam-builder-css')) return;
    var st = document.createElement('style');
    st.id = 'fwo-mam-builder-css';
    st.textContent = THEME.css;
    document.head.appendChild(st);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var instances = 0;

  function shellHtml() {
    return '<div class="js-fwo-mam-mode"></div><div class="js-fwo-mam-units"></div><div class="js-fwo-mam-axes"></div>' +
      '<p class="fwo-mam__photo-note js-fwo-mam-photo-note" hidden></p>' +
      '<div class="fwo-mam__summary js-fwo-mam-summary" hidden></div>' +
      '<p class="fwo-mam__missing js-fwo-mam-missing" hidden></p>';
  }

  // Pill + fieldset markup in this theme's classes — also used by quote-form.js's
  // options pop-up (FwoMamBuilder.ui) so both pop-ups look the same.
  function pill(name, value, label, on, extra) {
    return '<label class="fwo-config__option' + (on ? ' ' + THEME.selected : '') + '">' +
      '<input class="fwo-config__radio" type="radio" name="' + name + '" value="' + esc(value) + '"' + (on ? ' checked' : '') + '>' +
      '<span class="' + THEME.pillText + '">' + esc(label) + (extra ? ' <span class="fwo-mam__qty">' + esc(extra) + '</span>' : '') + '</span></label>';
  }
  function group(legendHtml, inner, desc) {
    return '<fieldset class="' + THEME.group + '"><legend class="' + THEME.legend + '">' + legendHtml + '</legend>' +
      '<div class="' + THEME.options + '">' + inner + '</div>' +
      (desc != null ? '<div class="fwo-mam__desc">' + esc(desc) + '</div>' : '') + '</fieldset>';
  }
  function create(root, data, hooks) {
    ensureStyles();
    hooks = hooks || {};
    var uid = 'fwomam' + (++instances);
    var cfg = (data && data.config) || {};
    var media = (data && data.media) || [];
    var units = (data && data.units) || [];
    var specialId = data && data.special ? String(data.special) : '';
    var axes = cfg.axes || [];
    var rules = cfg.images || [];
    // With stock on hand the customer picks a mode first; without, it's always special order.
    // With stock on hand, start on "Available now" (and pick the unit when there's just one).
    var mode = units.length ? 'stock' : 'special'; // 'stock' | 'special'
    var unitId = units.length === 1 ? String(units[0].id) : null;
    var state = {};      // axisId -> optionId (pills) | [optionIds] (multi) | string (text)
    var touched = false; // don't nag about missing choices before the first click
    var modeEl = root.querySelector('.js-fwo-mam-mode');
    var unitsEl = root.querySelector('.js-fwo-mam-units');
    var axesEl = root.querySelector('.js-fwo-mam-axes');
    var MODE = uid + '-mode', UNIT = uid + '-unit';

    function axisById(id) { for (var i = 0; i < axes.length; i++) if (axes[i].id === id) return axes[i]; return null; }
    function labelOf(axisId, optId) {
      var ax = axisById(axisId); if (!ax) return optId;
      for (var i = 0; i < (ax.options || []).length; i++) if (ax.options[i].id === optId) return ax.options[i].label;
      return optId;
    }
    // { axis: [ids] } is met when every listed axis currently holds one of its ids.
    function met(cond) {
      if (!cond) return true;
      for (var k in cond) {
        var v = state[k], ok = cond[k];
        if (Array.isArray(v) ? !v.some(function (x) { return ok.indexOf(x) !== -1; }) : ok.indexOf(v) === -1) return false;
      }
      return true;
    }
    function anyMet(cond) { // disable_if: ANY listed axis holding a listed id disables the option
      if (!cond) return false;
      for (var k in cond) { var o = {}; o[k] = cond[k]; if (met(o)) return true; }
      return false;
    }
    function visibleOptions(ax) { return (ax.options || []).filter(function (o) { return met(o.show_if); }); }
    function axisVisible(ax) { return met(ax.show_if) && (ax.type === 'text' || visibleOptions(ax).length > 0); }
    function optionUsable(o) { return met(o.show_if) && !anyMet(o.disable_if); }
    // required_if (2026-10-06): the axis is required only while its condition holds
    // (e.g. color when finish = spicchio). Text axes are optional unless required:true
    // or a met required_if; option axes are required unless required:false.
    function isRequired(ax) {
      if (ax.required_if) return met(ax.required_if);
      return ax.type === 'text' ? ax.required === true : ax.required !== false;
    }

    // Drop choices that a later change made invalid (e.g. a size that
    // belongs to another version), repeating until nothing else changes.
    function prune() {
      for (var pass = 0; pass < 5; pass++) {
        var changed = false;
        axes.forEach(function (ax) {
          var v = state[ax.id];
          if (v == null || v === '') return;
          if (!axisVisible(ax)) { delete state[ax.id]; changed = true; return; }
          if (ax.type === 'text') return;
          var usable = function (id) { var o = (ax.options || []).filter(function (x) { return x.id === id; })[0]; return o && optionUsable(o); };
          if (ax.type === 'multi') {
            var keep = v.filter(usable);
            if (keep.length !== v.length) { state[ax.id] = keep; changed = true; }
          } else if (!usable(v)) { delete state[ax.id]; changed = true; }
        });
        if (!changed) return;
      }
    }

    function renderStock() {
      modeEl.innerHTML = !units.length ? '' : group('Availability',
        pill(MODE, 'stock', 'Available now', mode === 'stock') +
        pill(MODE, 'special', 'Special order — build your own', mode === 'special'),
        mode === 'stock' ? 'Finished ovens we have on hand — the fastest way to get baking.' : mode === 'special' ? 'Made to order by MAM in Modena with exactly the options you choose.' : '');
      unitsEl.innerHTML = mode !== 'stock' ? '' : group('Choose your oven',
        units.map(function (u) { return pill(UNIT, String(u.id), u.title, String(u.id) === unitId); }).join(''));
      axesEl.style.display = mode === 'special' ? '' : 'none';
    }

    function render() {
      renderStock();
      if (mode === 'special') {
        axesEl.innerHTML = axes.map(function (ax) {
          if (!axisVisible(ax)) return '';
          var legend = esc(ax.label) + (!isRequired(ax) ? ' <span style="' + THEME.optionalStyle + '">(optional)</span>' : '');
          if (ax.type === 'text') {
            return '<fieldset class="' + THEME.group + '"><legend class="' + THEME.legend + '">' + legend + '</legend>' +
              '<input class="fwo-mam__text" type="text" maxlength="80" data-axis="' + esc(ax.id) + '" placeholder="' + esc(ax.placeholder || '') + '" value="' + esc(state[ax.id] || '') + '">' +
              (ax.help ? '<div class="fwo-mam__desc">' + esc(ax.help) + '</div>' : '') + '</fieldset>';
          }
          var selDesc = '';
          var pills = visibleOptions(ax).map(function (o) {
            var multi = ax.type === 'multi';
            var on = multi ? (state[ax.id] || []).indexOf(o.id) !== -1 : state[ax.id] === o.id;
            var off = anyMet(o.disable_if);
            if (on && o.desc) selDesc = o.desc;
            return '<label class="fwo-config__option' + (on ? ' ' + THEME.selected : '') + '"' +
              (off ? ' aria-disabled="true" title="Not available with your current choices"' : '') + '>' +
              '<input class="fwo-config__radio" type="' + (multi ? 'checkbox' : 'radio') + '" name="' + uid + '-' + esc(ax.id) + '" value="' + esc(o.id) + '"' +
              (on ? ' checked' : '') + (off ? ' disabled' : '') + ' data-axis="' + esc(ax.id) + '">' +
              '<span class="' + THEME.pillText + '">' + esc(o.label) + '</span></label>';
          }).join('');
          return group(legend, pills, selDesc);
        }).join('');
      }
      updateSummary();
      updateImage();
      if (touched) showMissing(missing(), false);
    }

    function missing() {
      if (!mode) return ['Availability'];
      if (mode === 'stock') return unitId ? [] : ['Choose your oven'];
      return axes.filter(function (ax) {
        if (ax.type === 'multi' || !axisVisible(ax) || !isRequired(ax)) return false;
        if (ax.type === 'text') return !String(state[ax.id] || '').trim();
        return !state[ax.id];
      }).map(function (ax) { return ax.label; });
    }
    function showMissing(list, scroll) {
      var el = root.querySelector('.js-fwo-mam-missing');
      if (!list.length) { el.hidden = true; return; }
      el.textContent = 'Please choose: ' + list.join(', ') + '.';
      el.hidden = false;
      if (scroll !== false) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function unitById(id) { return units.filter(function (u) { return String(u.id) === String(id); })[0] || null; }
    // "Version: Static | Cooking floor: Ø 120 cm | … | Accessories: Granite sill, Lower shelf"
    function builtSpec() {
      return axes.filter(axisVisible).map(function (ax) {
        var v = state[ax.id];
        if (v == null || v === '' || (Array.isArray(v) && !v.length)) return '';
        var text = ax.type === 'text' ? String(v).trim()
          : Array.isArray(v) ? v.map(function (id) { return labelOf(ax.id, id); }).join(', ')
          : labelOf(ax.id, v);
        return text ? ax.label + ': ' + text : '';
      }).filter(Boolean).join(' | ');
    }
    function spec() {
      if (mode === 'stock') { var u = unitById(unitId); return u ? 'Availability: In stock | Oven: ' + u.title : ''; }
      var built = builtSpec();
      return built && units.length ? 'Availability: Special order | ' + built : built;
    }
    function updateSummary() {
      var el = root.querySelector('.js-fwo-mam-summary');
      var s = spec();
      el.hidden = !s;
      el.innerHTML = s ? '<strong>' + (mode === 'stock' ? 'Your oven:' : 'Your build:') + '</strong><br>' + esc(s).split(' | ').join('<br>') : '';
    }

    // Photo: the chosen unit's variant image, or the most specific image rule
    // that fully matches the build. The host decides how to show it.
    var lastMid = null;
    function show(m) {
      if (!m || m.id === lastMid) return;
      lastMid = m.id;
      if (hooks.showMedia) hooks.showMedia(m);
    }
    function updateImage() {
      var note = root.querySelector('.js-fwo-mam-photo-note');
      if (mode !== 'special') {
        note.hidden = true;
        var u = unitById(unitId);
        if (u && u.media) show(media.filter(function (x) { return String(x.id) === String(u.media); })[0]);
        return;
      }
      var best = null, bestN = -1;
      rules.forEach(function (r) {
        var n = Object.keys(r.when || {}).length;
        var ok = Object.keys(r.when || {}).every(function (k) { return state[k] === r.when[k]; });
        if (ok && n > bestN) { best = r; bestN = n; }
      });
      if (!best || bestN === 0) {
        note.hidden = !(axisById('finish') && state.finish);
        note.textContent = 'We don’t have a photo of this exact finish yet — your MAM specialist will send samples with the quote.';
        return;
      }
      note.hidden = !best.note;
      note.textContent = best.note || '';
      show(media.filter(function (x) { return x.file && x.file.indexOf(best.file) !== -1; })[0]);
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === MODE) { mode = t.value; unitId = mode === 'stock' && units.length === 1 ? String(units[0].id) : null; render(); return; }
      if (t.name === UNIT) { unitId = t.value; render(); return; }
      var ax = t.getAttribute('data-axis');
      if (!ax) return;
      var def = axisById(ax);
      if (def.type === 'multi') {
        var cur = state[ax] || [];
        state[ax] = t.checked ? cur.concat([t.value]) : cur.filter(function (x) { return x !== t.value; });
      } else if (def.type !== 'text') {
        state[ax] = t.value;
      }
      prune();
      render();
    });
    root.addEventListener('input', function (e) {
      var t = e.target, ax = t && t.getAttribute('data-axis');
      if (!ax || !axisById(ax) || axisById(ax).type !== 'text') return;
      state[ax] = t.value;
      updateSummary(); // no re-render: keep focus in the text box
      if (touched) showMissing(missing(), false);
    });

    render();
    return {
      missing: function () { touched = true; return missing(); },
      showMissing: showMissing,
      spec: spec,
      // The variant the quote should carry: the chosen in-stock unit, or the
      // special-order variant ('' = no special-order variant found).
      variantId: function () { return mode === 'stock' ? (unitId || '') : specialId; }
    };
  }


  // ---- Oven options (non-MAM ovens) ----
  // The same questions as the product page — variant options (cascading: an option
  // only offers values that exist with the choices above it), ALFA Availability
  // (Available now = in-stock variants only), made-to-order Color, Fuel Type,
  // gas burner / base companions, Engraving — from the JSON in
  // snippets/fwo-quote-options-data.liquid. Used by the quote form's options
  // pop-up (quote-form.js → openQuoteOptions) and by the product-page picker
  // (snippets/fwo-oven-options.liquid). create() returns the same interface as the
  // MAM builder ({ missing, showMissing, spec, variantId }) plus companions() and
  // variant(), so the product page's Request a Quote handler works unchanged.
  var OO_SPECIAL = ' (special order)';

  function ooRealOptions(data) {
    var vs = data.variants || [];
    return (data.options || []).filter(function (n, i) {
      return !(vs.length === 1 && i === 0 && (vs[0].options || [])[0] === 'Default Title');
    });
  }

  // Does this product have anything to ask? (Otherwise the quote form just adds it.)
  function ooNeeded(data) {
    if (!data || !data.variants) return false;
    var vs = data.variants;
    var some = function (k) { return vs.some(function (v) { return (v[k] || []).length; }); };
    var stock = data.availability && vs.some(function (v) { return v.in_stock; });
    if ((data.colors || []).length || (data.special_colors || []).length || (data.fuels || []).length ||
        some('burners') || some('bases') || data.engraving || stock) return true;
    if (data.availability && ooRealOptions(data).length) return true; // special-order note + options
    return !!(data.oven && ooRealOptions(data).length && vs.length > 1);
  }

  var ooInstances = 0;
  function ooCreate(root, data, hooks) {
    ensureStyles();
    hooks = hooks || {};
    var name = 'fwooo' + (++ooInstances);
    var realOptions = ooRealOptions(data);
    var colors = data.colors || [], special = data.special_colors || [], fuels = data.fuels || [];
    var stockVariants = data.availability ? data.variants.filter(function (v) { return v.in_stock; }) : [];
    var askMode = stockVariants.length > 0;
    var start = null;
    for (var s = 0; s < data.variants.length; s++) if (String(data.variants[s].id) === String(hooks.variantId)) start = data.variants[s];
    start = start || data.variants[0];
    // mode: 'stock' | 'special' (null when the product has no availability step). With stock
    // on hand it starts on "Available now", landing on an in-stock variant (fixOpts below).
    var sel = { opts: (start.options || []).slice(), color: '', fuel: '', burner: 'wood', base: 'none',
      mode: askMode ? 'stock' : data.availability ? 'special' : null };
    var touched = false;

    root.innerHTML = '<div class="js-fwo-oo-groups"></div>' +
      (data.engraving ? '<fieldset class="' + THEME.group + '"><legend class="' + THEME.legend + '">Engraving <span style="' + THEME.optionalStyle + '">— optional, special order</span></legend>' +
        '<div class="fwo-mam__desc" style="margin:0 0 6px">Add your pizzeria name, engraved on the oven (longer lead time).</div>' +
        '<input type="text" class="fwo-mam__text js-fwo-oo-engraving" maxlength="50" autocomplete="off" placeholder="e.g. La Dolce Vita"></fieldset>' : '') +
      '<p class="fwo-mam__photo-note js-fwo-oo-photo-note" hidden>No photo of this exact option yet — the photo shows the standard finish.</p>' +
      '<p class="fwo-mam__missing js-fwo-oo-missing" hidden></p>';
    var noteEl = root.querySelector('.js-fwo-oo-photo-note');
    var groupsEl = root.querySelector('.js-fwo-oo-groups');
    var missingEl = root.querySelector('.js-fwo-oo-missing');

    function pool() { return sel.mode === 'stock' ? stockVariants : data.variants; }
    function matches(v, upto) {
      for (var k = 0; k < upto; k++) if ((v.options || [])[k] !== sel.opts[k]) return false;
      return true;
    }
    function currentVariant() {
      var p = pool();
      for (var i = 0; i < p.length; i++) if (matches(p[i], realOptions.length)) return p[i];
      return null;
    }
    // Option i offers only values that exist with the choices above it (e.g. QUICK 6P:
    // TOP comes only Wood-fired, so picking TOP leaves just Wood-fired under Fuel Type).
    function valuesFor(i) {
      var vals = [];
      pool().forEach(function (x) {
        if (!matches(x, i)) return;
        var val = (x.options || [])[i];
        if (val && vals.indexOf(val) < 0) vals.push(val);
      });
      return vals;
    }
    function fixOpts() {
      realOptions.forEach(function (_, i) {
        var vals = valuesFor(i);
        if (vals.length && vals.indexOf(sel.opts[i]) < 0) sel.opts[i] = vals[0];
      });
    }
    function imageFor() {
      var v = currentVariant();
      var combo = data.combo_images || {};
      var col = sel.color.replace(OO_SPECIAL, '');
      if (col) {
        var keys = [(v ? v.options : sel.opts).join('|') + '|' + col, sel.opts[0] + '|' + col, col];
        for (var i = 0; i < keys.length; i++) {
          var mid = combo[keys[i]];
          if (mid != null && data.media && data.media[String(mid)]) return { src: data.media[String(mid)], mediaId: String(mid) };
        }
      }
      if (v && v.image) return { src: v.image, mediaId: v.media_id ? String(v.media_id) : '' };
      // No photo for this exact variant: go back to the main photo (never leave the
      // previous color on screen) and say so.
      // (The note only matters when photos vary by option — not for e.g. PIZZARELLA 110V/230V.)
      var photosVary = data.variants.some(function (x) { return x.image; });
      if (data.image) return { src: data.image, mediaId: data.featured_media_id ? String(data.featured_media_id) : '', fallback: !!v && photosVary };
      return null;
    }
    function missing() {
      var out = [];
      if (askMode && !sel.mode) out.push('Availability');
      if (realOptions.length && !currentVariant()) out.push('an available combination');
      if ((colors.length || special.length) && !sel.color) out.push('Color');
      if (fuels.length && !sel.fuel) out.push('Fuel Type');
      return out;
    }
    function showMissing(list, scroll) {
      touched = true;
      var m = list || missing();
      missingEl.hidden = !m.length;
      missingEl.textContent = m.length ? 'Please choose: ' + m.join(', ') + '.' : '';
      if (m.length && scroll !== false && root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function groupsHtml() {
      var v = currentVariant();
      var html = '';
      if (askMode) {
        html += group('Availability',
          pill(name + '-mode', 'stock', 'Available now', sel.mode === 'stock') +
          pill(name + '-mode', 'special', 'Special order', sel.mode === 'special'),
          sel.mode === 'stock' ? 'Ready to ship from our stock.' : sel.mode === 'special' ? 'Made to order — longer lead time.' : null);
      } else if (data.availability) {
        html += '<p class="fwo-mam__photo-note">Special order: made to order — longer lead time.</p>';
      }
      realOptions.forEach(function (optName, i) {
        // In "Available now" the pool is in-stock units only, so just those options show (no quantities).
        html += group(esc(optName), valuesFor(i).map(function (val) { return pill(name + '-o' + i, val, val, sel.opts[i] === val); }).join(''));
      });
      if (colors.length || special.length) {
        var inner = colors.map(function (c) { return pill(name + '-color', c, c, sel.color === c); }).join('');
        if (special.length) {
          inner += '<p class="fwo-mam__desc" style="flex-basis:100%;margin:6px 0 0">Special order — made to your color (longer lead time)</p>' +
            special.map(function (c) { return pill(name + '-color', c + OO_SPECIAL, c, sel.color === c + OO_SPECIAL); }).join('');
        }
        html += group('Color', inner);
      }
      if (fuels.length) html += group('Fuel Type', fuels.map(function (f) { return pill(name + '-fuel', f, f, sel.fuel === f); }).join(''));
      var burners = (v && v.burners) || [];
      if (burners.length) {
        html += group('Fuel Type', pill(name + '-burner', 'wood', 'Wood-fired', sel.burner === 'wood') +
          burners.map(function (b) { return pill(name + '-burner', String(b.id), 'Gas/Wood Hybrid (' + b.label + ')', sel.burner === String(b.id)); }).join(''));
      }
      var bases = (v && v.bases) || [];
      if (bases.length) {
        html += group('Base', pill(name + '-base', 'none', 'No base', sel.base === 'none') +
          bases.map(function (b) { return pill(name + '-base', String(b.id), b.label, sel.base === String(b.id)); }).join(''));
      }
      return html;
    }
    function paint() {
      groupsEl.innerHTML = groupsHtml();
      var img = imageFor();
      noteEl.hidden = !(img && img.fallback);
      if (img && hooks.showImage) hooks.showImage(img, currentVariant());
      if (touched) showMissing(null, false);
    }
    groupsEl.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.name || input.name.indexOf(name + '-') !== 0) return;
      var key = input.name.slice(name.length + 1);
      if (key === 'mode') sel.mode = input.value;
      else if (key.charAt(0) === 'o') sel.opts[Number(key.slice(1))] = input.value;
      else if (key === 'color') sel.color = input.value;
      else if (key === 'fuel') sel.fuel = input.value;
      else if (key === 'burner') sel.burner = input.value;
      else if (key === 'base') sel.base = input.value;
      fixOpts(); // keep later options valid for the new choice (and on an in-stock unit in "Available now")
      // Burners / bases belong to a variant — reset them when it changes.
      var v = currentVariant();
      if (!v || !(v.burners || []).some(function (b) { return String(b.id) === sel.burner; })) sel.burner = 'wood';
      if (!v || !(v.bases || []).some(function (b) { return String(b.id) === sel.base; })) sel.base = 'none';
      paint();
      if (hooks.onChange) hooks.onChange();
    });
    fixOpts();
    paint();

    function find(list, id) { for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) return list[i]; return null; }
    return {
      missing: missing,
      showMissing: showMissing,
      variant: function () { return currentVariant(); },
      variantId: function () { var v = currentVariant(); return v ? String(v.id) : ''; },
      // Burner / base the customer picked — added to the quote as their own lines.
      companions: function () {
        var v = currentVariant() || {};
        return [find(v.burners || [], sel.burner), find(v.bases || [], sel.base)].filter(Boolean);
      },
      // One label carrying every choice ("Availability: Special order · Style: TOP · Color: Corten").
      spec: function () {
        var v = currentVariant() || {};
        var parts = [];
        if (sel.mode) parts.push('Availability: ' + (sel.mode === 'stock' ? 'In stock' : 'Special order'));
        realOptions.forEach(function (optName, i) { if (sel.opts[i]) parts.push(optName + ': ' + sel.opts[i]); });
        if (sel.color) parts.push('Color: ' + sel.color);
        if (sel.fuel) parts.push('Fuel Type: ' + sel.fuel);
        if ((v.burners || []).length) parts.push('Fuel Type: ' + (find(v.burners, sel.burner) ? 'Gas/Wood Hybrid' : 'Wood-fired'));
        var eng = root.querySelector('.js-fwo-oo-engraving');
        if (eng && eng.value.trim()) parts.push('Engraving: ' + eng.value.trim());
        return parts.join(' · ').slice(0, 900);
      }
    };
  }

  window.FwoMamBuilder = { create: create, shellHtml: shellHtml, ensureStyles: ensureStyles, ui: { pill: pill, group: group },
    ovenOptions: { create: ooCreate, needed: ooNeeded } };
})();
